var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"p-status-dot"},[_c('div',{staticClass:"p-status-dot__dot",class:{
      'p-status-dot--online': _vm.props.status === 'online',
    }}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }